import React from 'react';
import { Progress, Tooltip } from 'antd';
import { convertISOToDateTimeWithoutSeconds } from '../../../../util/timezone';
import { getAlertColorCode } from '../../utils';
import { normalizeAlertScore } from '../../../../util/normalization';
import {
  BulkIconContainer,
  StyledAlertId,
  StyledButton,
  StyledDiv,
  StyledLink
} from './styled';
import HitSummary from '../../components/HitSummary';
import BulkIcon from '../../../../assets/icon_ns_bulk.png';

const MailSendIcon = (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="#2b73e0"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0H1.33333C0.6 0 0 0.615789 0 1.36842V9.57895C0 10.3316 0.6 10.9474 1.33333 10.9474H7.33333V9.57895H1.33333V2.73684L6.66667 6.1579L12 2.73684V6.1579H13.3333V1.36842C13.3333 0.615789 12.7333 0 12 0ZM6.66667 4.78947L1.33333 1.36842H12L6.66667 4.78947ZM11.3333 7.52632L14 10.2632L11.3333 13V10.9474H8.66667V9.57895H11.3333V7.52632Z" />
  </svg>
);

const SentIcon = (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="#4776A2"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.13919 8.62356L0.164977 5.64935C0.0877713 5.57215 0.116286 5.44095 0.218573 5.40276L12.0508 0.984725C12.1709 0.939874 12.2883 1.05664 12.244 1.17699L7.87679 13.06C7.83901 13.1628 7.70738 13.1918 7.62994 13.1143L4.7081 10.1925C4.65435 10.1387 4.6493 10.0533 4.69634 9.99358L9.28663 4.16744C9.39751 4.0267 9.21288 3.84513 9.07401 3.95836L3.34004 8.63375C3.28039 8.68239 3.19361 8.67798 3.13919 8.62356Z"
      fillOpacity="0.8"
    />
  </svg>
);

export default {
  defaultProperties: {
    render: (text) => text || '-'
  },
  customProperties: {
    alertId: {
      render: (text) => <StyledAlertId>{text}</StyledAlertId>
    },
    primaryPartyName: {
      render: (text) => (
        <div style={{ maxWidth: 100, overflow: 'hidden', maxHeight: 48 }}>
          <Tooltip placement="right" title={text}>
            <b>{text}</b>
          </Tooltip>
        </div>
      )
    },
    createdUser: {
      render: (text) => <div style={{ maxWidth: 100 }}>{text || '-'}</div>
    },
    hitsSummary: {
      render: (_, { hitsSummary }) => <HitSummary data={hitsSummary} />
    },
    alertLevel: {
      render: (_, { alertLevel, alertScore }) => {
        const score = normalizeAlertScore(alertScore || 0);
        return (
          <StyledDiv>
            <div>
              {alertLevel} <b>{score.toFixed(2)}%</b>
            </div>
            <Progress
              percent={score}
              strokeColor={getAlertColorCode(alertLevel)}
              showInfo={false}
              size="small"
            />
          </StyledDiv>
        );
      }
    },
    alertDate: {
      render: (text) => (text ? convertISOToDateTimeWithoutSeconds(text) : '-')
    },
    alertSourceId: {
      render: (_, { alertSourceId }) => {
        return alertSourceId === '28' ? (
          <BulkIconContainer>
            <img style={{ paddingRight: 4 }} src={BulkIcon} alt="" />
            Bulk
          </BulkIconContainer>
        ) : (
          <div>Single</div>
        );
      },
      align: 'center'
    },
    isSentToCm: {
      render: (_, { isSentToCm, onSendToCMClick }) =>
        isSentToCm ? (
          <StyledButton disabled={isSentToCm} icon={SentIcon}>
            Sent
          </StyledButton>
        ) : (
          <StyledButton
            icon={MailSendIcon}
            onClick={(e) => {
              e.stopPropagation();
              onSendToCMClick();
            }}>
            Send to CM
          </StyledButton>
        ),
      align: 'center'
    },
    listDetails: {
      render: (_, { onClickLabel, runInstanceId, customerSegmentCode }) => (
        <>
          <StyledLink
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
              onClickLabel('watchlist', runInstanceId, customerSegmentCode);
            }}>
            Watchlist
          </StyledLink>
          <br />
          <StyledLink
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
              onClickLabel('whitelist', runInstanceId, customerSegmentCode);
            }}>
            Whitelist
          </StyledLink>
        </>
      )
    }
  }
};
